// extracted by mini-css-extract-plugin
export default {"mainInputLine":"quantity-block__mainInputLine___r9UUa"};